import React, { useEffect, useState } from 'react';
import { IComponentHot, IComponentHotOne } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { style } from '../../utils/image';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import './AllForHot.scss';
import '../common.scss';
import { alpha } from '../../utils/color';
import useHot from './useHot';
import { getScrollCls } from '../../utils/util';
import PCScroller from './PCScroller';

export default function AllForHot(props: IComponentHot) {
  const { template, title, hot_list } = props;
  const { setBigIndex, borderColor, h1Color, bigIndex, bigList } = useHot(
    props
  );

  const renderVerticalImage = function(img: string, index: number) {
    return (
      <div className="list-one" onClick={() => setBigIndex(index)} key={index}>
        <img src={style(img, 'wx_250_350')} className={'one-photo vertical'} />
      </div>
    );
  };

  const renderHorizontalImage = function(img: string, index: number) {
    return (
      <div className="list-one" onClick={() => setBigIndex(index)} key={index}>
        <img
          src={style(img, 'wx_555_350')}
          className={'one-photo horizontal'}
        />
      </div>
    );
  };

  // list的模式下，没法显示desc
  const renderTemplate1 = function(list: IComponentHotOne[]) {
    if (!list || !list.length) {
      return;
    }
    // 一张
    const len = list.length;
    const imgList = [];
    const firstImg = list[0].image;
    const lastImg = list[len - 1].image;
    if (len === 1) {
      imgList.push(renderVerticalImage(firstImg, 0));
    } else if (len === 2) {
      list.forEach((one, index) => {
        imgList.push(renderVerticalImage(one.image, index));
      });
    } else {
      // >=3
      imgList.push(renderVerticalImage(firstImg, 0));
      const centerList = list.slice(1, -1);
      centerList.forEach((one, index) => {
        imgList.push(renderHorizontalImage(one.image, index + 1));
      });
      // 最后一个
      imgList.push(renderVerticalImage(lastImg, len - 1));
    }
    // 图片张数>=4时平均分2行显示
    if (len >= 4) {
      const half = Math.ceil(len / 2); //取天花板，第一行可以比第二行多1个
      return (
        <div className={classNames('hot-list template1', getScrollCls())}>
          <div className="row row1">{imgList.slice(0, half)}</div>
          <div className="row row2">{imgList.slice(half)}</div>
        </div>
      );
    }
    return (
      <div
        className={classNames('hot-list template1', getScrollCls())}
        style={{ display: 'flex' }}
      >
        {imgList}
      </div>
    );
  };

  return (
    <div className={'all-for-hot hot-pic-component decoratev2-comp-com'}>
      <div className="row-wrapper" style={{ color: h1Color }}>
        {title && (
          <p className="title" style={{ color: h1Color }}>
            {title}
          </p>
        )}
        <PCScroller>
          {template === 'template1' ? (
            renderTemplate1(hot_list)
          ) : (
            <div className={classNames('hot-list', getScrollCls(), template)}>
              {hot_list.map((one, index) => (
                <div
                  className={'list-one'}
                  key={index}
                  onClick={() => {
                    setBigIndex(index);
                  }}
                >
                  <img
                    src={style(one.image, 'wx_375_375_square')}
                    className={'one-photo'}
                    style={{ border: `1px solid ${borderColor}` }}
                  />
                  <div className={'one-name'}>{one.desc}</div>
                </div>
              ))}
            </div>
          )}
        </PCScroller>
      </div>
      <SimpleBigPic
        pageType="HotList"
        index={bigIndex}
        list={bigList}
        setIndex={setBigIndex}
        showDetail={true}
      />
    </div>
  );
}
